import React, { useEffect, useState } from "react";
import {
  Box,
  List,
  ListItemButton,
  Typography,
  CircularProgress,
  Divider,
  Skeleton,
  Tooltip,
} from "@mui/material";
import {
  ExpandLess,
  ExpandMore,
  CheckCircle,
  ChevronRight,
  RadioButtonUnchecked,
} from "@mui/icons-material";
import { useSelector } from "react-redux";
import UploadCatalogContent from "./../../components/SetupConnectors/subConnectorComponents/UploadCatalogContent";
import DefaultCompleted from "./../../components/SetupConnectors/subConnectorComponents/DefaultCompleted";
import DefaultIncompleted from "./../../components/SetupConnectors/subConnectorComponents/DefaultIncompleted";
import { useChannelConfig } from "./../../components/SetupConnectors/channelConfig";
import { useSearchParams } from "react-router-dom";
import ConnectAmazonPortal from "./ConnectAmazonPortal";

export default function IntegrationPage() {
  const dashboardSideBarVisibiltyState = useSelector(
    (state) => state.dashboardData.dashboardSideBarVisibiltyState
  );

  const { channelConfig, loading, error, refreshAmazonConnectionStatus } =
    useChannelConfig();
  const [searchParams, setSearchParams] = useSearchParams();

  const [selectedChannel, setSelectedChannel] = useState("amazon"); //default selected channel is amazon
  const [selectedSub, setSelectedSub] = useState(null);

  const handleChannelSelect = (channelId) => {
    setSelectedChannel(channelId === selectedChannel ? null : channelId);
    setSelectedSub(null);
    setSearchParams({ selectedChannel: channelId });
  };

  const handleSubSelect = (sub) => {
    setSelectedSub(sub);
    setSearchParams({
      selectedChannel,
      subConnection: sub.id,
    });
  };

  function RightContentPageDefaultLayout({ children }) {
    let selectedChannelConfig = channelConfig.find(
      (channel) => channel.id === selectedChannel
    );
    let selectedSubConnectionConfig = selectedChannelConfig[
      "subConnections"
    ].find((subConnection) => subConnection.id === selectedSub.id);

    return (
      <Box display="flex" flexDirection="column" height="100%">
        {/* Header */}
        <Box px={2} py={3} display="flex" alignItems="center" gap={1}>
          <Box
            component="span"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 24,
              height: 24,
            }}
          >
            {React.cloneElement(selectedChannelConfig.icon, {
              style: { width: 20, height: 20 }, // enforce fixed size
            })}
          </Box>

          <Typography fontWeight="bold" variant="title1">
            {selectedSubConnectionConfig.name}
          </Typography>
        </Box>

        <Divider />
        {children}
      </Box>
    );
  }

  // Render Right-Side Content
  const renderContent = () => {
    if (!selectedSub) {
      return (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          height="100%"
        >
          <Typography variant="body2" color="text.secondary">
            Select a sub-connection from the left side
          </Typography>
        </Box>
      );
    }
    if (selectedSub.id === "FK_LISTING_CSV_SYNC") {
      return (
        <RightContentPageDefaultLayout>
          <UploadCatalogContent
            key={"FK_LISTING_CSV_SYNC"}
            jobType={"FK_LISTING_CSV_SYNC"}
            selectedChannel={selectedChannel}
          />
        </RightContentPageDefaultLayout>
      );
    } else if (selectedSub.id === "FK_STATS_CSV_SYNC") {
      return (
        <RightContentPageDefaultLayout>
          <UploadCatalogContent
            key={"FK_STATS_CSV_SYNC"}
            jobType={"FK_STATS_CSV_SYNC"}
            selectedChannel={selectedChannel}
          />
        </RightContentPageDefaultLayout>
      );
    }
      else if (selectedSub.id === "MYNTRA_LISTING_CSV_SYNC") {
      return (
        <RightContentPageDefaultLayout>
          <UploadCatalogContent
            key={"MYNTRA_LISTING_CSV_SYNC"}
            jobType={"MYNTRA_LISTING_CSV_SYNC"}
            selectedChannel={selectedChannel}
          />
        </RightContentPageDefaultLayout>
      );
    } else if (selectedSub.id === "MYNTRA_STATS_CSV_SYNC") {
      return (
        <RightContentPageDefaultLayout>
          <UploadCatalogContent
            key={"MYNTRA_STATS_CSV_SYNC"}
            jobType={"MYNTRA_STATS_CSV_SYNC"}
            selectedChannel={selectedChannel}
          />
        </RightContentPageDefaultLayout>
      );
    } else if (selectedSub.id === "AMAZON_LISTING_CSV_SYNC") {
      return (
        <RightContentPageDefaultLayout>
          <UploadCatalogContent
            key={"AMAZON_LISTING_CSV_SYNC"}
            jobType={"AMAZON_LISTING_CSV_SYNC"}
            selectedChannel={selectedChannel}
          />
        </RightContentPageDefaultLayout>
      );
    } else if (selectedSub.id === "AMAZON_STATS_CSV_SYNC") {
      return (
        <RightContentPageDefaultLayout>
          <UploadCatalogContent
            key={"AMAZON_STATS_CSV_SYNC"}
            jobType={"AMAZON_STATS_CSV_SYNC"}
            selectedChannel={selectedChannel}
          />
        </RightContentPageDefaultLayout>
      );
    } else if (selectedSub.id === "seller" || selectedSub.id === "vendor") {
      return (
        <RightContentPageDefaultLayout>
          <ConnectAmazonPortal
            portal={selectedSub.id}
            onAccountsChanged={refreshAmazonConnectionStatus}
          />
        </RightContentPageDefaultLayout>
      );
    } else if (!!selectedSub.completed) {
      return (
        <RightContentPageDefaultLayout>
          <DefaultCompleted title={selectedSub.name} />
        </RightContentPageDefaultLayout>
      );
    }
    return (
      <RightContentPageDefaultLayout>
        <DefaultIncompleted title={selectedSub.name} />
      </RightContentPageDefaultLayout>
    );
  };

  useEffect(() => {
    const channelFromUrl = searchParams.get("selectedChannel");
    const subFromUrl = searchParams.get("subConnection");

    if (channelFromUrl) {
      setSelectedChannel(channelFromUrl);
    }

    if (subFromUrl) {
      // Try to find the matching subConnection object
      const channel = channelConfig.find((c) => c.id === channelFromUrl);
      const sub = channel?.subConnections.find((s) => s.id === subFromUrl);
      if (sub) {
        setSelectedSub(sub);
      }
    }
  }, [searchParams, channelConfig]);

  return (
    <div
      style={{ marginTop: dashboardSideBarVisibiltyState ? "72px" : "72px" }}
      className={
        dashboardSideBarVisibiltyState
          ? "main-content-container-onopen-mode"
          : "main-content-container-oncolapse-mode"
      }
      id="main-box"
    >
      <Box display="flex" height="calc(100vh - 72px)">
        {/* Left Panel */}
        <Box
          sx={{
            width: "50%",
            borderRight: "1px solid #eee",
            p: 3,
            bgcolor: "#fff",
            overflowY: "auto",
          }}
        >
          <Typography variant="h6" fontWeight={"semibold"}>
            Integration
          </Typography>
          <Typography variant="body2" color="text.secondary" mb={4}>
            Seamlessly Link Your Stores and Data in One Place
          </Typography>

          {/* Outer Wrapper with one Header */}
          <Box
            sx={{
              borderRadius: "8px",
              border: "1px solid var(--elevation-outlined, #E0E0E0)",
              overflow: "hidden",
            }}
          >
            {/* Global Header */}
            <Box
              sx={{
                bgcolor: "#F7F6FF",
                px: 2,
                py: 2,
              }}
            >
              <Typography variant="body2">Set Up Channel Data</Typography>
            </Box>

            {/* Channel List */}
           <List sx={{ py: 0 }}>
      {loading
        ? // Skeleton placeholders
          Array.from(new Array(3)).map((_, idx) => (
            <React.Fragment key={idx}>
              {/* Main skeleton row */}
              <ListItemButton>
                <Box position="relative" display="inline-flex" mr={1} my={1}>
                  <Skeleton variant="circular" width={18} height={18} />
                </Box>
                <Skeleton
                  variant="rectangular"
                  width="60%"
                  height={20}
                  sx={{ borderRadius: 1 }}
                />
              </ListItemButton>

              {/* Sub skeleton rows */}
              {Array.from(new Array(2)).map((__, subIdx) => (
                <ListItemButton key={subIdx} sx={{ pl: 5 }}>
                  <Skeleton variant="circular" width={18} height={18} />
                  <Skeleton
                    variant="rectangular"
                    width="50%"
                    height={18}
                    sx={{ ml: 1, borderRadius: 1 }}
                  />
                </ListItemButton>
              ))}
            </React.Fragment>
          ))
        : // Actual data
          channelConfig.map((channel) => {
            const completedCount = channel.subConnections.filter(
              (s) => s.completed
            ).length;
            const total = channel.subConnections.length;
            const progress = (completedCount / total) * 100;

            return (
              <React.Fragment key={channel.id}>
                {/* Main Connection */}
                <ListItemButton
                  onClick={() => handleChannelSelect(channel.id)}
                >
                  <Box position="relative" display="inline-flex" mr={1}>
                    {/* Gray background circle */}
                    <CircularProgress
                      variant="determinate"
                      value={100}
                      size={18}
                      thickness={10}
                      sx={{
                        color: "#e0e0e0",
                        position: "absolute",
                        left: 0,
                      }}
                    />
                    {/* Green progress circle */}
                    <CircularProgress
                      variant="determinate"
                      value={progress}
                      size={18}
                      thickness={10}
                      sx={{ color: "green" }}
                    />
                  </Box>

                  {channel.icon}

                  <Typography
                    variant="body2"
                    sx={{ py: 1, ml: 1, flex: 1 }}
                  >
                    {channel.name}
                  </Typography>

                  {selectedChannel === channel.id ? (
                    <ExpandLess />
                  ) : (
                    <ExpandMore />
                  )}
                </ListItemButton>

                {/* Sub Connections */}
                {selectedChannel === channel.id &&
                  channel.subConnections.map((sub) => {
                    const sellerConnected = channel.subConnections.some(
                      (item) => item.id === "seller" && item.completed
                    );
                    const vendorConnected = channel.subConnections.some(
                      (item) => item.id === "vendor" && item.completed
                    );
                    const selectionBlocked =
                      channel.id === "amazon" &&
                      ((sub.id === "seller" && vendorConnected && !sellerConnected) ||
                        (sub.id === "vendor" && sellerConnected && !vendorConnected));
                    const selectionMessage = vendorConnected
                      ? "A Vendor account is already connected. Currently we support only one connected account."
                      : "A Seller account is already connected. Currently we support only one connected account.";

                    return (
                    <Tooltip
                      key={sub.id}
                      title={selectionBlocked ? selectionMessage : ""}
                      placement="right"
                    >
                    <span style={{ display: "block" }}>
                    <ListItemButton
                      sx={{
                        pl: 5,
                        "&.Mui-selected": {
                          backgroundColor: "#FAFAFA",
                          "&:hover": {
                            backgroundColor: "#FAFAFA",
                          },
                        },
                      }}
                      selected={selectedSub?.id === sub.id}
                      disabled={selectionBlocked}
                      onClick={() => {
                        if (!selectionBlocked) handleSubSelect(sub);
                      }}
                    >
                      {sub.completed ? (
                        <CheckCircle
                          fontSize="small"
                          sx={{ color: "green" }}
                        />
                      ) : (
                        <RadioButtonUnchecked
                          fontSize="small"
                          sx={{ color: "gray" }}
                        />
                      )}

                      <Typography
                        variant="body2"
                        sx={{ py: 1, ml: 1, flex: 1 }}
                      >
                        {sub.name}
                      </Typography>

                      {/* Show right arrow only when selected */}
                      {selectedSub?.id === sub.id && (
                        <ChevronRight
                          fontSize="small"
                          sx={{ color: "gray" }}
                        />
                      )}
                    </ListItemButton>
                    </span>
                    </Tooltip>
                    );
                  })}
              </React.Fragment>
            );
          })}
    </List>
          </Box>
        </Box>

        {/* Right Panel */}
        <Box
          sx={{
            width: "50%",
            // p: 3,
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {renderContent()}
        </Box>
      </Box>
    </div>
  );
}